import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import BackendService from '../services/backendService';
import { generateUniqueId } from '../utils/general';
import { useMetrics } from './useMetrics';
import useRouterMatch from './useRouterMatch';

export const useUploadPresentation = () => {
  const client = useQueryClient();
  const metrics = useMetrics();
  const { templateId } = useRouterMatch();
  const { mutate: upload, isError, isLoading, isSuccess, reset, data } = useMutation(
    async ({
      file,
      onUploadProgress,
    }: {
      file: File;
      onSuccessFunction?: () => void;
      onUploadProgress?: (event: any) => void;
    }) => {
      const fileId = generateUniqueId().toString();
      const filePath = `${fileId}_${file.name}`;
      const data = await BackendService.instance.getUploadUrl(`game_files/${filePath}`);
      const url = data.data;
      await axios.request({
        url,
        method: 'PUT',
        timeout: 60 * 1000,
        headers: {
          'Content-Type': file?.type,
        },
        data: file,
        onUploadProgress: onUploadProgress && onUploadProgress,
      });
      const fileTypes = file.name.split('.');
      const fileType = fileTypes[fileTypes.length - 1];

      return { filePath, fileType };
    },
    {
      onSuccess: (data, { onSuccessFunction }) => {
        if (onSuccessFunction) {
          onSuccessFunction();
        }
        const templateCacheKey = ['template', templateId];
        client.invalidateQueries(templateCacheKey);
        metrics.logEvent('Creator.Upload.Presentation.Generator.Success', { templateId });
      },
    },
  );

  return {
    upload,
    isUploading: isLoading,
    isSuccess: isSuccess,
    isError,
    fileInfo: data,
    reset,
  };
};
